import React from 'react';

// Extracted verbatim from Landing.jsx's main tabbed portal (previously the
// `userType === 'visitor' && portalData.voucherMode !== 'separate'` block).
// Behavior/markup unchanged — see authRegistry.js for how this is wired up.
const VoucherLoginFields = ({ formData, handleInputChange }) => (
    <div className="form-group animate-fade-in">
        <label>Voucher Code</label>
        <div className="input-with-icon">
            <i className="fas fa-key"></i>
            <input
                type="text"
                name="voucherCode"
                className="input"
                placeholder="Enter access code"
                required
                value={formData.voucherCode}
                onChange={handleInputChange}
            />
        </div>
    </div>
);

export default VoucherLoginFields;
